// extracted by mini-css-extract-plugin
module.exports = {"item":"List_item__2L3Tg","group":"List_group__3vGN1","title":"List_title__38OIA"};